export default {
    textHeader: 'Qr code Scanner',
    msgError: 'Please scan again.',
    msgSuccess: 'Successfully check-in.'
}
